import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { htmlParser, EditorState, ContentState, convertFromHTML, convertToRaw, headerViewerLink, Typography, Divider } from "../../../../../";

var AcademyCourseView = function AcademyCourseView(props) {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      links = _useState2[0],
      setLinks = _useState2[1];

  var editorState = EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(props.data).contentBlocks, convertFromHTML(props.data).entityMap));
  useEffect(function () {
    setLinks(headerViewerLink(convertToRaw(editorState.getCurrentContent()), true));
  }, [props.data]);

  var createContent = function createContent() {
    var dataFinal = props.data; // console.log("content initial", props.data);

    links.forEach(function (link) {
      dataFinal = dataFinal.replace(/<h(.?\d*?(?!.*?id=).*?)>/, "<h".concat(link.type, " id=\"").concat(link.link, "\" style=\"padding-top:80px\">"));
    });
    return htmlParser(dataFinal);
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, props.description), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "fixed",
      width: "22%"
    }
  }, links.map(function (link) {
    return link.html;
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8,
    md: 8,
    lg: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, props.title), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, props.description), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginTop: "20px",
      height: "5px",
      marginLeft: "30%",
      width: "40%",
      backgroundColor: "#3f9"
    }
  }), createContent()));
};

export { AcademyCourseView };